import { createFileRoute } from '@tanstack/react-router';
import { redirectFromLanding } from '../../router/route-utils';

export const Route = createFileRoute('/_authenticated/')({
  staticData: {
    pageName: '',
  },
  beforeLoad: async ({ context }) => {
    await redirectFromLanding(context);
  },
  component: () => null,
});
